// IconButton — 아이콘 전용 버튼. aria-label 필수.
// Button을 내부에서 사용하되, 정사각 패딩 + 레이블 없음으로 특화.

import { forwardRef, type ReactNode } from 'react';
import { Button, type ButtonVariant, type ButtonSize, type ButtonProps } from './Button';

export interface IconButtonProps extends Omit<ButtonProps, 'startIcon' | 'endIcon' | 'children'> {
  /** 아이콘 노드 */
  icon: ReactNode;
  /** 스크린리더 레이블 — 필수 */
  'aria-label': string;
  variant?: ButtonVariant;
  size?: ButtonSize;
}

/**
 * Locker UI — IconButton
 * @example
 * <IconButton icon={<MoreHorizontal />} aria-label="더보기" />
 */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon, className = '', ...rest }, ref) => {
    return (
      <Button
        ref={ref}
        className={`ui-icon-btn ${className}`}
        startIcon={icon}
        {...rest}
      />
    );
  },
);

IconButton.displayName = 'IconButton';
